const countries = require('i18n-iso-countries');
const enCountryLabels = require('i18n-iso-countries/langs/en.json');
const frCountryLabels = require('i18n-iso-countries/langs/fr.json');

var template = require('./profile_tax_info.html.slim')
declare var angular;

export class ProfileTaxResidencyController {
  static $inject = ['ProfileTaxInfo', '$routeParams', 'locale', 'brand']

  canadianSin;
  foreignTins:any = null;
  documentSignedDate = null;
  documentUrl = null;
  signUrl = null;
  crsUrl: string;

  constructor(private ProfileTaxInfo, private $routeParams, private locale, private brand) {
    countries.registerLocale(enCountryLabels);
    countries.registerLocale(frCountryLabels);

    this.crsUrl = this.getCrsUrl(this.brand.getBrand())
    ProfileTaxInfo.get({user_id: $routeParams.userId}).$promise.then(
      (response) => {
        const sin = response.sin.entry;
        this.canadianSin = [sin.slice(0, 3), ' ', sin.slice(3, 6), ' ', sin.slice(6, 9)].join('');

        const countryListLocale = locale.getCurrentLanguage() === 'french' ? 'fr' : 'en';
        const tins = [];
        response.tins.forEach((tin) => {
          tins.push({
            country: countries.getName(tin.countryCode, countryListLocale),
            entry: tin.entry,
          });
        })

        this.foreignTins = tins;
        this.documentSignedDate = response.agreement.updated;
        this.documentUrl = response.agreement.documentUrl;
        this.signUrl = response.agreement.signUrl;
      }
    )
  }
  getCrsUrl(brandname) {
    if (brandname == "assante") {
      return "https://support.assanteconnect.com/51827-general-questions/354909"
    } else {
      return "https://help.cidirectinvesting.com/10762-general-questions/what-is-the-common-reporting-standard-crs?from_search=25795590#page_content"
    };
  };

  public goToWorkflow() {
    window.location.assign('/app/tax-residency');
  }
}

angular.module('wbComponents')
  .controller("ProfileTaxInfoController", ProfileTaxResidencyController)
  .directive('profileTaxInfo', function() {
    return {
      restrict: 'E',
      templateUrl: template,
      controller: "ProfileTaxInfoController",
      controllerAs: 'ctrl',
      replace: true,
    }
  });
